
function SetInnerHTML({ content, title,description }:any) {


  return (
    <article className="max-w-screen-lg mx-auto space-y-5 prose ck-content">
      <h1 className='text-4xl font-bold'>
        {title}
      </h1>
      <div className="font-bold" dangerouslySetInnerHTML={{ __html: description }}></div>
      <div dangerouslySetInnerHTML={{ __html: content }}></div>
    </article>
  )
}

export default SetInnerHTML
